"use client";
import {SupportChat,sendSupportHttp} from "@dj/site-navigation/support-chat";
import {reactWebAuthHref,getReactWebBaseUrl} from "@/lib/reactWebAuthUrl";
export function PublicSupportChat({locale}:{locale:string}){
 const endpoint=process.env.NEXT_PUBLIC_SUPPORT_CHAT_ENDPOINT;
 const enabled=process.env.NEXT_PUBLIC_SUPPORT_CHAT_ENABLED==="true"&&Boolean(endpoint);
 if (!enabled) return null;
 const returnTo=`${getReactWebBaseUrl()}/#/${locale}/support`;
 return <SupportChat signupTarget="_blank" locale={locale} enabled={enabled} signupHref={reactWebAuthHref(locale,"signup",{returnTo})} send={input=>sendSupportHttp(endpoint!,input)}/>;
}
